<template>
  <div>
    <upload-instructions :isOrgUseDummyEmail="isOrgUseDummyEmail" />
    <slot v-if="hideUploader">
      {{ $t("organizations.invite_users.multiple_mail_to_invite", { numberOfInvites: numberOfEmails }) }}
    </slot>
    <el-upload
      v-loading="loading"
      class="upload-files"
      :action="actionUrl"
      :before-upload="getActionUrl"
      :http-request="submitFile"
      :on-success="onSuccess"
      v-bind:class="{ 'hide-uploader': hideUploader, 'hide-file-list': hideFileList }"
      :drag="true"
      :file-list="form.fileList"
      :show-file-list="true"
      :auto-upload="true"
      :on-change="updateFileList"
      :limit="1"
      :on-remove="updateFileList"
    >
      <i class="elsa-icon-import-grey"></i>
      <div class="el-upload__text">
        {{ $t("organizations.invite_users.import.instructions") }}
        <p>{{ $t("common.or") }}</p>
        <chip icon="">
          {{ $t("organizations.invite_users.import.browse_files") }}
        </chip>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { warningMessage, successMessage } from "../../../utils/messages";
import { uploadFile, readFile, allowedTypes } from "../../../utils/uploader";
import { STUDENT } from "@/constants/userRoles";
import UploadInstructions from "@/components/common/UploadInstructions";
import { compose, pathOr, isEmpty, includes, length, path } from "ramda";
import Chip from "@/components/common/Chip";
export default {
  components: {
    UploadInstructions,
    Chip,
  },
  props: {
    organizationId: {},
    form: {},
    isOrganizationUseDummyEmail: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      loading: false,
      actionUrl: "",
      uploadId: null,
      errors: null,
      numberOfEmails: 0,
    };
  },
  computed: {
    hideUploader() {
      return this.form.fileList.length > 0;
    },
    hideFileList() {
      return this.form.fileList.length === 0;
    },
    isOrgUseDummyEmail() {
      if (this.isOrganizationUseDummyEmail === undefined) {
        return this.$store.getters["organization/isOrganizationUseDummyEmail"];
      } else {
        return this.isOrganizationUseDummyEmail;
      }
    },
    ...mapGetters({
      classes: "classes/getClassList",
      currentOrganizationType: "organization/currentOrganizationType",
      // isOrgUseDummyEmail: "organization/isOrganizationUseDummyEmail",
    }),
  },
  methods: {
    async getActionUrl(file) {
      this.loading = true;
      this.errors = false;
      const fileSize = file.size;
      const contentType = file.type;
      const organizationId = this.organizationId;
      const groupId = null;
      const fileName = file.name;
      const role = STUDENT;
      const payload = {
        fileSize,
        contentType,
        organizationId,
        groupId,
        fileName,
        role,
      };
      if (!includes(contentType, allowedTypes)) {
        this.errors = true;
        this.updateFileList(null, []);
        this.loading = false;
        warningMessage(this.$t("common.file_type_not_allowed"))(this);
        return Promise.reject(false);
      }
      try {
        const req = await this.getInviteUploadUrl({
          ...payload,
        });

        this.actionUrl = req.data.presigned_url;
        this.uploadId = req.data.id;
      } catch (e) {
        // show warning
        // please try again
        this.errors = true;
        this.updateFileList(null, []);
        this.loading = false;
        warningMessage(this.$t("common.generic_error_message"))(this);
        return Promise.reject(false);
      }
    },
    async submitFile(request) {
      try {
        const { action: url, file } = request;
        const rawFile = await readFile(file);
        return await uploadFile(url, file.type, rawFile);
      } catch (e) {
        this.errors = true;
        this.loading = false;
        return warningMessage(this.$t("common.generic_error_message"))(this);
      }
    },
    async onSuccess(response, file, fileList) {
      try {
        const params = { is_flow_invite: this.isOrgUseDummyEmail === false ? 1 : 0 };
        const req = await this.getInviteUploadEmails({
          uploadId: this.uploadId,
          params,
        });

        if (compose(isEmpty, pathOr([], ["data", "emails"]))(req)) {
          this.loading = false;
          return warningMessage(this.$t("common.generic_error_message"))(this);
        }
        let emails = [];
        if (req && req.data) {
          for (let i = 0; i < req.data.emails.length; i++) {
            emails.push({
              text: req.data.emails[i],
              first_name: req.data.first_names[i],
              last_name: req.data.last_names[i],
              selectedTeam: this.getClassIdByName(req.data.groups ? req.data.groups[i] : null),
            });
          }
        }
        this.$emit("update-add-learner", { users: emails });
        this.numberOfEmails = compose(length, pathOr([], ["data", "emails"]))(req);
        this.$emit("update-form", { fileReady: true });
        this.loading = false;
      } catch (e) {
        // show warning
        this.errors = true;
        this.loading = false;
        return warningMessage(this.$t("common.generic_error_message"))(this);
      }
    },
    getClassIdByName(name) {
      let klass = this.classes.find(x => x.name === name);
      if (klass) {
        return klass.id;
      }
      return null;
    },
    updateFileList(file, fileList) {
      this.$emit("update-form", { fileList: fileList });
    },
    ...mapActions("invite", ["getInviteUploadUrl", "getInviteUploadEmails"]),
  },
};
</script>
